import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LkPersonalForm } from "./LkPersonalForm";
import banner from "../../assets/images/lk/lk-personal-banner.png";
import { useStores } from "hooks/useStores";
import { ROUTES_PATHS } from "const";
import "../../styles/lkPersonal.css"
import { deleteAuthCookies } from "utils/Cookie";


export default function LkPersonal() {
  const [deleteAccModal, setDeleteAccModal] = useState(false);
  const [deleteConfirmed, setDeleteConfirmed] = useState(false);
  const [userId, setUserId] = useState();

  const { api } = useStores();

  const deleteAcc = () => setDeleteAccModal(true);
  const closeDeleteModal = () => setDeleteAccModal(false);

  useEffect(() => {
    api.user.getCurrentUser()
      .then((res) => setUserId(res.id))
      .catch((err) => {
        if (err.response.status === 401) {
          deleteAuthCookies()
        }
      });

  }, []);

  const deleteAccConfirmation = () => {
    api.user.deleteUser(userId)
      .then(() => {
        setDeleteConfirmed(true);
      })
  };

  return (
    <div className='lk-personal'>
      <section className='lk-personal-banner'>
        <div className='lk-personal-banner__text'>
          Вы можете менять данные, подтверждать почту, управлять аккаунтом. Для
          оформленния заказа нужно заполнить все обязательные поля
        </div>
        <div className='lk-personal-banner__image'>
          <img loading="lazy" src={banner} alt='' />
        </div>
      </section>

      <section className='lk-personal-deleteAcc'>
        <button onClick={deleteAcc} className='lk-personal-deleteAcc__link'>
          Удалить аккаунт
        </button>
        {deleteAccModal && (
          <div className='lk-personal-deleteAcc__modal'>
            <div className='lk-personal-deleteAcc__modal-content'>
              {deleteConfirmed ? (
                <>
                  <Link
                    className='lk-personal-deleteAcc__modal-closeBtn'
                    to={ROUTES_PATHS.MAIN}
                  />
                  <h3 className='lk-personal-deleteAcc__modal-title'>
                    Ваш аккаунт успешно удалён
                  </h3>
                </>
              ) : (
                <>
                  <a
                    className='lk-personal-deleteAcc__modal-closeBtn'
                    onClick={closeDeleteModal}
                  >
                    {""}
                  </a>
                  <h3 className='lk-personal-deleteAcc__modal-title'>
                    Вы уверены что хотите удалить аккаунт?
                  </h3>
                  <button
                    onClick={deleteAccConfirmation}
                    className='lk-personal-deleteAcc__modal-button'
                  >
                    Удалить аккаунт
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </section>

      <section >
        <LkPersonalForm />
      </section>
    </div>
  );
}
